import { render, staticRenderFns } from "./logout.pug?vue&type=template&id=d067a1ca&lang=pug&external"
import script from "./logout.js?vue&type=script&lang=js&external"
export * from "./logout.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports